/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MergeDocumentsRequestItem } from './MergeDocumentsRequestItem';
import {
    MergeDocumentsRequestItemFromJSON,
    MergeDocumentsRequestItemFromJSONTyped,
    MergeDocumentsRequestItemToJSON,
    MergeDocumentsRequestItemToJSONTyped,
} from './MergeDocumentsRequestItem';

/**
 * 
 * @export
 * @interface MergeDocumentsRequest
 */
export interface MergeDocumentsRequest {
    /**
     * 
     * @type {Array<MergeDocumentsRequestItem>}
     * @memberof MergeDocumentsRequest
     */
    items: Array<MergeDocumentsRequestItem>;
}

/**
 * Check if a given object implements the MergeDocumentsRequest interface.
 */
export function instanceOfMergeDocumentsRequest(value: object): value is MergeDocumentsRequest {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function MergeDocumentsRequestFromJSON(json: any): MergeDocumentsRequest {
    return MergeDocumentsRequestFromJSONTyped(json, false);
}

export function MergeDocumentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MergeDocumentsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(MergeDocumentsRequestItemFromJSON)),
    };
}

export function MergeDocumentsRequestToJSON(json: any): MergeDocumentsRequest {
    return MergeDocumentsRequestToJSONTyped(json, false);
}

export function MergeDocumentsRequestToJSONTyped(value?: MergeDocumentsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(MergeDocumentsRequestItemToJSON)),
    };
}

